import { v4 as uuidv4 } from 'uuid';

import { AI_MEDIA_TYPES } from '../../../constants';
import sendRequest from '../../../service/sendRequest';
import callApi from '../../../service/callApi';
import { storeMedia } from '../../../ai-playground/media-store/mediaStore';
import arrayBufferToBase64 from '../../../utils/arrayBufferToBase64';

export const mediaStrategy = {
  supports: (assistant) => {
    return assistant.type === AI_MEDIA_TYPES.IMAGE || assistant.type === AI_MEDIA_TYPES.VIDEO;
  },

  init: async (assistant, message) => {
    const response = await sendRequest(
      () =>
        callApi.post(`/api/ai/playground/media?type=${assistant.value}&prompt=${encodeURIComponent(message)}`, null, {
          responseType: 'arraybuffer',
        }),
      {
        onError: (e) => {
          throw e;
        },
      },
    );

    const mediaId = uuidv4();
    const base64Data = arrayBufferToBase64(response.data);
    const mediaType = assistant.type;

    storeMedia(mediaId, base64Data, mediaType);

    return {
      mediaId,
      mediaType,
    };
  },

  reply: async (assistant, reply) => {
    return mediaStrategy.init(assistant, reply);
  },
};
